export const convertFiltersToQueryString = (filters) => {
  const updatedFilters = {
    ...filters,
    ...filters.customFields,
  };
  delete updatedFilters.customFields;

  // Filter out null or empty values
  const filteredFilters = Object.fromEntries(
    Object.entries(updatedFilters).filter(([key, value]) => {
      if (Array.isArray(value) && value.length === 0) {
        return false; // Skip empty assignedTo array
      } else if (Array.isArray(value)) {
        // Extract only _id from assignedTo array
        return true;
      }
      return value !== null && value !== '' && value !== undefined;
    }),
  );

  // Build query string based on filteredFilters
  let queryString = '';
  if (Object.keys(filteredFilters).length > 0) {
    queryString =
      '?' +
      Object.entries(filteredFilters)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            // Extract only _id from assignedTo array
            const vals = value.map((item) => item._id);
            return `${key}=${vals.join(',')}`;
          }
          return `${key}=${value}`;
        })
        .join('&');
  }

  return queryString;
};
